export const CommonConstant = {
    CURRENT_LANGUAGE :"currentLanguage",
    CHINESE_LANGUAGE :"Chinese - simplified",
}